import { Route, Routes } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import { Active } from './views/Active';
import { Root } from './views/Root';
import { Order as OrderView } from './views/Order';
import { authenticatedState } from '../Account/atoms';
import { Flex } from '../GlobalComponents/Flex';
import { Container } from '../GlobalComponents/Container';
import { Outer } from '../Layout/Router/Outer';

export const Order: React.FC = () => {
	const authenticated = useRecoilValue(authenticatedState);

	return (
		<Flex $justifyContent="center">
			<Container width="1140">
				<Routes>
					<Route path="/" element={<Outer />}>
						{authenticated && (
							<>
								<Route path="/" element={<Root />} />
							</>
						)}

						<Route path="/active" element={<Active />} />
						<Route path="/:id" element={<OrderView />} />
					</Route>
				</Routes>
			</Container>
		</Flex>
	);
};
